var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.893,
    height: 22.897,
    viewBox: "0 0 23.893 22.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fan",
    d: "M48.619,29.678a6.824,6.824,0,0,0-10.193-4.032L40.291,18.2a.91.91,0,0,0-.392-.987A6.824,6.824,0,1,0,33,28.985l-7.378,2.107a.91.91,0,0,0-.66.833,6.825,6.825,0,1,0,13.639.083l5.514,5.336a.91.91,0,0,0,1.052.154A6.824,6.824,0,0,0,48.619,29.678Zm-13.761-.8a1.82,1.82,0,1,1,1.82,1.82A1.82,1.82,0,0,1,34.858,28.882Zm-3.639-5.914a5,5,0,0,1,7.137-4.529l-1.7,6.8a3.639,3.639,0,0,0-3.175,1.911A4.987,4.987,0,0,1,31.218,22.968Zm3.071,13.6a5,5,0,0,1-7.49-3.916l6.745-1.927a3.639,3.639,0,0,0,3.133,1.8h.1A4.984,4.984,0,0,1,34.289,36.567Zm12.075-2.616a5,5,0,0,1-1.479,1.608l-5.041-4.878a3.629,3.629,0,0,0-.067-3.7,5,5,0,0,1,6.586,6.974Z",
    transform: "translate(-24.958 -16.163)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAssetIcon);
export default __webpack_public_path__ + "static/media/Nav-AssetIcon.748c71c2252cb1a8a0bded842d8898c7.svg";
export { ForwardRef as ReactComponent };